export default "__VITE_ASSET__B3dZCz8f__"